import { render, staticRenderFns } from "./PurchaseDocumentSearchBrowse.vue?vue&type=template&id=cdd2b08a"
import script from "./PurchaseDocumentSearchBrowse.vue?vue&type=script&lang=ts"
export * from "./PurchaseDocumentSearchBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdd2b08a')) {
      api.createRecord('cdd2b08a', component.options)
    } else {
      api.reload('cdd2b08a', component.options)
    }
    module.hot.accept("./PurchaseDocumentSearchBrowse.vue?vue&type=template&id=cdd2b08a", function () {
      api.rerender('cdd2b08a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseDocumentSearchBrowse.vue"
export default component.exports